import React from "react";
import Footer from "./Footer";
import Navbar from "./Navbar"; // Если у тебя есть Navbar
import styles from "./Layout.module.css";
// import LanguageSwitcher from "./LanguageSwitcher";


const Layout = ({ children }) => {
  return (
    <div className={styles.wrapper}>
      <Navbar />
      <main className={styles.content}>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
